import React from "react";
import "./MenuAccessModal.css"; // See CSS below

// Mocking some icons with SVG or using a library like Lucide
const CloseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export default function MenuAccessModal({
  visible,
  onDismiss,
  loadingAccess,
  accessData,
  toggleAccess,
  saveAccessChanges,
  isSaving,
}) {
  if (!visible) return null;

  return (
    <div className="access-modal-overlay">
      <div className="access-modal-container">
        {/* Header */}
        <div className="access-modal-header">
          <div>
            <h2 className="access-modal-title">Menu Access Control</h2>
            <p className="access-modal-subtitle">
              Manage user visibility and permissions
            </p>
          </div>
          <button className="close-button" onClick={onDismiss}>
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="access-modal-body">
          {loadingAccess ? (
            <div className="loading-state">
              <div className="spinner"></div>
              <span>Fetching permissions...</span>
            </div>
          ) : (
            <div className="access-scroll-area">
              {accessData.map((menu) => (
                <div key={menu.id} className="menu-group-card">
                  {/* Top Level Menu */}
                  <div className="menu-row parent">
                    <span className="menu-name">{menu.name}</span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={Boolean(menu.is_active)}
                        onChange={() => toggleAccess(menu.id)}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>

                  {/* Subpanels */}
                  <div className="subpanel-list">
                    {menu.subpanels.map((sub) => (
                      <div key={sub.id} className="subpanel-section">
                        <div className="menu-row sub">
                          <span className="subpanel-name">{sub.name}</span>
                          <label className="switch small">
                            <input
                              type="checkbox"
                              checked={Boolean(sub.is_active)}
                              onChange={() => toggleAccess(menu.id, sub.id)}
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>

                        {/* Sub-titles */}
                        {sub.subtitles?.length > 0 && (
                          <div className="subtitle-grid">
                            {sub.subtitles.map((st) => (
                              <div key={st.id} className="subtitle-item">
                                <span className="subtitle-name">{st.name}</span>
                                <label className="switch tiny">
                                  <input
                                    type="checkbox"
                                    checked={Boolean(st.is_active)}
                                    onChange={() =>
                                      toggleAccess(menu.id, sub.id, st.id)
                                    }
                                  />
                                  <span className="slider round"></span>
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="access-modal-footer">
          <button className="btn-outline" onClick={onDismiss}>
            Cancel
          </button>
          <button
            className="btn-primary"
            onClick={saveAccessChanges}
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Save Permissions"}
          </button>
        </div>
      </div>
    </div>
  );
}
